// extracted by mini-css-extract-plugin
module.exports = {"container":"Anchor_container__RJNti","mini":"Anchor_mini__1pTpr","highlight":"Anchor_highlight__3_VrI","button":"Anchor_button__xcA_x","disabled":"Anchor_disabled__10zWj"};